<div class="ui-g-12">

  <div class="campaigncharts">
    <div class="ui-g">
      <div class="ui-g-5 ui-md-5 ui-sm-12 card" style="padding: 0 2em" pTooltip="{{ 'customerShoppingHabits.segment_filter_help' | translate }}">
        <div class="ui-g-6 ui-md-6 ui-sm-6">

          <h3>{{ 'customerShoppingHabits.start_segment' | translate }}</h3>

          <div *ngFor="let cluster of clusterList" class="ui-g-12 ui-md-12 ui-sm-12">
            <input type="checkbox" value="{{cluster.code}}" (click)="clickStartSegment(cluster)"/> {{cluster.description}}
          </div>
        </div>

        <div class="ui-g-6 ui-md-6 ui-sm-6">
          <h3>{{ 'customerShoppingHabits.destination_segment' | translate }}</h3>

          <div *ngFor="let cluster of clusterList" class="ui-g-12 ui-md-12 ui-sm-12">
            <input type="checkbox" value="{{cluster.code}}" (click)="clickDestSegment(cluster)"/> {{cluster.description}}
          </div>
        </div>
      </div>

      <div class="ui-g-7 ui-md-7 ui-sm-12" *ngIf="data != null">
        <h3>{{ 'loyalty_chart.migrationFlow' | translate }}</h3>
        <div class="chart-container">
          <chart [options]="migrationFlowChart.options" (load)="setChartSankeyInstance(migrationFlowChart, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

</div>







// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-evolution/customer-evolution.component.html